import { Component } from '@angular/core';

import 'style-loader!./radio-group-stretcher.component.deep.scss';

@Component({
  selector: 'nz-radio-group-stretcher',
  templateUrl: 'radio-group-stretcher.component.html',
  styleUrls: ['radio-group-stretcher.component.scss'],
})
export class RadioGroupStretcherComponent {
}
